import React from 'react';

function ProgramExplanationBox({ title, description }) {
  return (
    <div className="w-full h-full p-6 bg-white border border-gray-200 border-b-4 border-b-[#FFD82D] rounded-xl shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
      <h3 className="text-lg font-extrabold text-[#162E3B] mb-3">
        {title}
      </h3>
      <p className="text-gray-700 text-base leading-relaxed">
        {description}
      </p>
    </div>
  );
}

export default ProgramExplanationBox;
